import { FC, useState } from "react";
import { IEntitySimpleDTO } from "../../../../libs/coreapi-dto/@types/common";
import { v4 as uuidv4 } from 'uuid';
import RegisterPriceByGoodsPluginSettings from "./RegisterPriceByGoodsPluginSettings";
import { useTranslation } from "react-i18next";
import { GridSelectorModalWindow } from "../../../../components/modalWindows/GridSelectorModalWindow";
import RegisterPriceByGoodsGrid from "./RegisterPriceByGoodsGrid";

interface IRegisterPriceByGoodsSelectorModalProps extends IGridSelectorModalProps {
    goodsIdGlobal?: string;
    registerPrice?: number;
    rowId?: string;
}

const RegisterPriceByGoodsSelectorModal: FC<IRegisterPriceByGoodsSelectorModalProps> = (props) => {

    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [focusTaken, setFocusTaken] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false)
    const gridId = uuidv4();
    const plugin = RegisterPriceByGoodsPluginSettings
    const { t } = useTranslation();
   
    return (
        <GridSelectorModalWindow
            gridDisplayName={"Реестровые цены товара"}
            entityToPressEnter={entity}
            focusTaken={focusTaken}
            ok={{
                onClick: () => {
                    props.ok?.(entity)
                },
                disabled: disabled
            }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                plugin
                    ? <RegisterPriceByGoodsGrid
                        gridId={gridId}
                        plugin={plugin}
                        data={entity}
                        isModal
                        baseGridFilter={props.gridFilter}
                        multipleSelect={props.multipleSelect}
                        goodsIdGlobal={props.goodsIdGlobal}
                        onFocusChanged={(taken: boolean) => {
                            setFocusTaken(taken);
                        }}
                        onSelect={(row, rowDto) => {
                            if (row && rowDto && rowDto.deleted === false) {
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                                setDisabled(false)
                            } else if (row && rowDto && rowDto.deleted === true) {
                                setDisabled(true)
                            } else if (row) {
                                setDisabled(false)
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            }
                        }}
                        onDoubleClick={(row, rowDto) => {
                            if (row && rowDto && rowDto.deleted === false) {
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                                props.ok?.({ idGlobal: row.idGlobal, displayName: row.displayName })
                            }
                        }}
                    />
                    : <p> {t('general.directoryNotConfigured')} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default RegisterPriceByGoodsSelectorModal